import type { ApiError } from '@/shared/api';

/**
 * Kuratierte deutsche Nutzer-Meldungen für die Akte-Mutations-Fehler (Design-Brief §3.6).
 * Der Backend-`code` landet via ProblemDetails im `title` (BaseController.ToProblem);
 * `detail` trägt die (oft schon deutsche) Server-Meldung als Fallback.
 */
export const AKTE_ERROR_MESSAGES: Record<string, string> = {
  file_locked: 'Dieser Beleg ist gesperrt (GoBD) und kann nicht verändert werden.',
  move_out_of_category:
    'Verschieben ist nur innerhalb derselben Kategorie möglich. Zum Wechsel der Kategorie nutzen Sie „Kategorie ändern".',
  invalid_target_folder: 'Dieser Zielordner ist ungültig.',
  reclassify_to_system_kind:
    'In „Ausgangsrechnung" kann nicht umklassifiziert werden — System-Belege entstehen automatisch.',
  issued_on_required: 'Für diese Kategorie ist ein Beleg-Datum erforderlich.',
  image_limit_reached: 'Das Limit von 30 Bildern pro Apartment ist erreicht.',
  invalid_ids: 'Die Datei-Auswahl für den Download war ungültig.',
  too_many_files:
    'Zu viele Dateien für einen ZIP-Download. Bitte in kleineren Gruppen herunterladen.',
  zip_too_large:
    'Die Auswahl ist für einen ZIP-Download zu groß. Bitte in kleineren Gruppen herunterladen.',
  invalid_custom_folder:
    'Ordner können nur innerhalb einer Kategorie angelegt werden. Basis-Ordner sind geschützt.',
  invalid_folder_name: 'Bitte geben Sie einen gültigen Ordnernamen an.',
  folder_exists: 'Ein Ordner mit diesem Namen existiert bereits.',
  folder_not_empty: 'Der Ordner enthält noch Dateien. Verschieben oder löschen Sie diese zuerst.',
  property_file_not_found:
    'Die Datei wurde nicht gefunden. Sie wurde möglicherweise bereits verschoben.',
  property_not_found: 'Das Apartment wurde nicht gefunden.',
  // Upload-Validierung (UploadValidator + Controller):
  file_mime_not_allowed:
    'Dieses Dateiformat wird nicht unterstützt. Erlaubt sind PDF, JPG, PNG und WebP.',
  file_magic_byte_mismatch:
    'Der Dateiinhalt passt nicht zum Dateiformat. Bitte laden Sie eine gültige Datei hoch.',
  file_too_large: 'Die Datei ist zu groß (max. 50 MB).',
  file_empty: 'Die Datei ist leer.',
  file_required: 'Es wurde keine Datei ausgewählt.',
  metadata_required: 'Die Upload-Angaben fehlen.',
  metadata_invalid: 'Die Upload-Angaben sind ungültig.',
};

const GENERIC = 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.';

/** Übersetzt einen ApiError in eine kuratierte DE-Meldung (Code → String, sonst Server-Detail). */
export function akteErrorMessage(err: ApiError): string {
  const byCode = err.title ? AKTE_ERROR_MESSAGES[err.title] : undefined;
  return byCode ?? err.detail ?? GENERIC;
}
